export default "__VITE_ASSET__67c1f841__"